import {EditTwoTone} from '@ant-design/icons';
import {Button, Col, Input, message, Row, Tabs, Tooltip, Typography} from "antd";
import querystring from "query-string";
import {Component} from 'react';
import cookie from "react-cookies";
import {connect} from "react-redux";
import {get, post, post_response} from "../helper/request";
import {changePage, updateCaseSearch} from '../redux_actions/search.case.action';
import CliaView from './cliaview';
import {error_manager} from "../helper/error_manager";
import {aclPermissions, hasPermissions} from "../const/ACLPermissions";

const {Search} = Input;
const {TabPane} = Tabs;
const {Title} = Typography;
const {TextArea} = Input;

class SingleValidationView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedValidationId: '',
            type: 'assigned',
            total_count: '',
            assigned_name: '',
            unassigned_name: '',
            search: '',
            description: '',
            assigned_count: '',
            unassigned_count: '',
            edit_name_description: false,
            old_name: '',
            old_description: '',
            validationIds: [],
            key: '1',
        }

        this.is_clia_staff = hasPermissions([aclPermissions.clia_staff])
    }

    componentWillMount = () => {
        this.getValidationData(this.props.match.params.id);
        this.getCasesCount();
        this.getAllValidationIds();
    }

    getAllValidationIds = () => {
        let url = `/api/get_all_validation_id/`;
        post(url, querystring.stringify({user: parseInt(cookie.load('user_id'))}))
            .then(resp_data => {
                let data = resp_data['data']
                let ids = []
                for (let i = 0; i < data.length; i++) {
                    ids.push(data[i].id)
                }
                this.setState({validationIds: ids})
            })
    }

    getValidationData = (id) => {
        let url = `/api/get_validation_data/?id=${this.props.match.params.id}`;
        get(url)
            .then(data => {
                this.setState({
                    selectedValidationId: data['name'],
                    description: data['description']
                })
            })
    }

    componentDidUpdate = (prevProps, prevState) => {
        if (prevState.type !== this.state.type) {
            this.props.dispatch(changePage(1, this.props.urlState))
        }
    }

    onTabChange = (key, event) => {
        if (key === '1') {
            this.setState({
                type: 'assigned',
                key: '1'
            })
        } else {
            this.setState({
                type: 'unassigned',
                key: '2',
            })
        }
    }
    getCasesCount = () => {
        let url = `/api/total_cases_count/?id=${this.props.match.params.id}`;
        get(url)
            .then(data => {
                this.setState({
                    total_count: data["count"],
                    assigned_count: data['assigned_count'],
                    unassigned_count: data['unassigned_count']
                })
                let assigned_name = ""
                let unassigned_name = ""
                if (this.state.type === "assigned") {
                    assigned_name = `Assigned (${this.state.assigned_count})`
                    unassigned_name = `Unassigned (${this.state.unassigned_count})`
                } else {
                    assigned_name = `Assigned (${this.state.assigned_count})`
                    unassigned_name = `Unassigned (${this.state.unassigned_count})`
                }
                this.setState({
                    assigned_name: assigned_name,
                    unassigned_name: unassigned_name
                })
            })
    }

    onCaseSearch = (value) => {
        this.setState({
            selectedRowKeys: [],
        })
        this.props.dispatch(updateCaseSearch(value, this.props.urlState));
    }

    onInputChange = (e) => {
        if (e.target.value === '') {
            this.onSearchReset();
        }
        this.setState({
            search: e.target.value,
        });
    }
    onSearchReset = () => {
        if (this.state.search !== '') {
            let search = '';
            this.props.dispatch(updateCaseSearch(search, this.props.urlState));
            this.setState({
                search,
                // selectedRowKeys: [],
            });
        }
    }

    changeValidationName = (newName) => {
        this.setState({
            selectedValidationId: newName.target.value,
        })
    }

    changeValidationDescription = (newDescription) => {
        this.setState({
            description: newDescription.target.value,
        })
    }

    editValidationNameDescriptionSwitch = () => {
        let edit_name_description = this.state.edit_name_description
        if (edit_name_description) {
            this.setState({
                selectedValidationId: this.state.old_name,
                description: this.state.old_description,
            })
        } else {
            this.setState({
                old_name: this.state.selectedValidationId,
                old_description: this.state.description,
            })
        }
        this.setState({
            edit_name_description: !edit_name_description,
        })
    }

    submitNameandDescription = () => {
        let validationIds = this.state.validationIds;
        if (validationIds.includes(this.state.selectedValidationId) && this.state.selectedValidationId !== this.state.old_name) {
            message.warn("Validation Name already exists. Chose Another")
            return;
        }
        let url = `/api/update_validation/`;
        post_response(url, querystring.stringify({
            id: this.props.match.params.id, name: this.state.selectedValidationId,
            description: this.state.description
        }))
            .then(response => {
                this.setState({
                    edit_name_description: !this.state.edit_name_description,
                })
                message.success("Validation Updated Successfully")
            }).catch(err => {
            error_manager("Validation couldn't be updated!", err)
        })
    }

    render() {
        let headerSwitchButton;
        if (this.is_clia_staff && !this.state.edit_name_description) {
            headerSwitchButton = <Tooltip placement="right" title={"Edit Validation Name/Description"}>
                <Button onClick={this.editValidationNameDescriptionSwitch}>
                    <EditTwoTone/>
                </Button>
            </Tooltip>

        }

        let header;
        if (this.is_clia_staff && this.state.edit_name_description) {
            header = <div>
                <Row>
                    <Col span={6} offset={0.5}>
                        <Input
                            value={this.state.selectedValidationId}
                            onChange={this.changeValidationName}
                            defaultValue={this.state.description}
                            onChange={this.changeValidationDescription}
                            placeholder={"Enter Validation Study Description here"}
                            style={{width: '25%'}}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <TextArea
                            autosize={{minRows: 2, maxRows: 4}}
                            defaultValue={this.state.description}
                            onChange={this.changeValidationDescription}
                            placeholder={"Enter Validation Study Description here"}
                            style={{width: '25%'}}
                        />
                        <Button style={{marginLeft: '10px', marginTop: '40px'}} onClick={this.submitNameandDescription}>
                            SUBMIT
                        </Button>
                        <Button style={{marginLeft: '10px', marginTop: '40px'}}
                                onClick={this.editValidationNameDescriptionSwitch}>
                            CANCEL
                        </Button>
                    </Col>
                </Row>
                <Row>

                </Row>
            </div>
        } else {
            header = <div>
                <Row>
                    <Col span={10} offset={0.5}>
                        <Title> {this.state.selectedValidationId} </Title>
                    </Col>
                    <Col style={{display: 'flex', justifyContent: 'flex-end'}}>
                        {headerSwitchButton}
                    </Col>
                </Row>
                <Row>
                    <Col span={6} offset={0.5}>
                        {this.state.description}
                    </Col>

                    <Col span={6}
                         offset={this.state.description === null || this.state.description === undefined || this.state.description === '' ? 6 : 1}
                         style={{marginTop: '0px', marginBottom: '10px'}}>
                        <Search
                            value={this.state.search || ''}
                            onChange={this.onInputChange}
                            placeholder="Search by Folder name"
                            onSearch={this.onCaseSearch}
                            enterButton
                        />
                    </Col>
                    <Col span={4} style={{marginTop: '0px', marginBottom: '10px'}}>
                        <Button type="danger" onClick={this.onSearchReset} style={{marginLeft: 10}}>
                            Reset
                        </Button>
                    </Col>
                </Row>
            </div>
        }

        let cases_component;
        if (this.is_clia_staff) {
            cases_component = <Tabs defaultActiveKey="1" onTabClick={this.onTabChange} destroyInactiveTabPane={true}
                                    activeKey={this.state.key}>
                <TabPane tab={this.state.assigned_name} key="1">
                    <CliaView validationId={this.props.match.params.id} forceRender={true} type={"assigned"}
                              total_count={this.state.assigned_count}/>
                </TabPane>
                <TabPane tab={this.state.unassigned_name} key="2">
                    <CliaView validationId={this.props.match.params.id} forceRender={true} type={"unassigned"}
                              total_count={this.state.unassigned_count}/>
                </TabPane>
            </Tabs>
        } else {
            cases_component = <CliaView validationId={this.props.match.params.id} type={this.state.type}
                                        total_count={this.state.unassigned_count}/>
        }

        return (
            <div className={"full-parent all-slides"}>
                {header}
                {cases_component}
            </div>

        )
    }
}

const mapStateToProps = state => {
    return {
        allCases: state.casesReducer,
        total: state.caseStatusReducer.total,
        urlState: state.searchCaseReducer,
    };
};

export default connect(mapStateToProps)(SingleValidationView);
